export enum StatusType {
  Inactivity = 1,
  InBed,
  WithSecondPersonInRoom,
  InRoom,
  OutOfRoom,
  InBathroom,
  Unknown,
  Off,
  OutOfBed,
  InChair,
}
